import { useEffect, useRef, useState } from "react";

const slides = [
  { title: "MDE", category: "SELECTED WEB PROJECT", type: "image", image: "/img/portfolio/hp_02.jpg" },
  { title: "FULL-STACK", category: "REACT · VUE · JAVA · SPRING", type: "stack" },
  { title: "VISUAL", category: "DESIGN · COMMERCE", type: "image", image: "/img/detail_page/pr_04.jpg" }
];

const Header = ({ data }) => {
  const [active, setActive] = useState(0);
  const stageRef = useRef(null);
  useEffect(() => { const t = setInterval(() => setActive(v => (v + 1) % slides.length), 5000); return () => clearInterval(t); }, []);
  const move = (e) => {
    if (!stageRef.current || !window.matchMedia("(pointer:fine)").matches) return;
    const r = stageRef.current.getBoundingClientRect();
    stageRef.current.style.setProperty("--px", `${((e.clientX-r.left)/r.width-.5)*18}px`);
    stageRef.current.style.setProperty("--py", `${((e.clientY-r.top)/r.height-.5)*14}px`);
  };
  return <header id="top" className="hero hero-v7">
    <div className="hero-kinetic" aria-hidden="true"><span>BUILD</span><span>RUN</span><span>GROW</span></div>
    <div className="site-container hero-layout-v7">
      <div className="hero-copy-v7" data-motion>
        <p className="eyebrow eyebrow-on-dark">IRUN · DIGITAL PRODUCT STUDIO</p>
        <h1><span>아이디어를</span><span>실제로 작동하는</span><span className="accent">서비스로.</span></h1>
        <p className="hero-description-v7">{data?.description}</p>
        <div className="hero-actions-v7"><a className="magnetic-pill" href="#work">WORKS <b>↘</b></a><a className="text-link-on-dark" href="#contact">START A PROJECT ↗</a></div>
      </div>
      <div className="hero-stage-v7" ref={stageRef} onPointerMove={move} onPointerLeave={() => { if(stageRef.current){stageRef.current.style.setProperty('--px','0px');stageRef.current.style.setProperty('--py','0px')}}} data-motion>
        <div className="stage-frame-v7">
          <div className="stage-top"><span>IRUN / SELECTED</span><span>0{active+1} — 03</span></div>
          <div className="stage-screen-v7">
            {slides.map((s,i)=><div className={`stage-slide-v7 ${i===active?'is-active':''}`} key={s.title}>{s.type==='image'?<img src={s.image} alt={s.title}/>:<div className="stack-visual-v7"><b>React / Vue</b><i>+</i><b>Java / Spring</b><i>+</i><b>Data / API / Batch</b></div>}</div>)}
            <div className="stage-label-v7"><span>{slides[active].category}</span><strong>{slides[active].title}</strong></div>
          </div>
          <div className="stage-nav-v7">{slides.map((s,i)=><button onClick={()=>setActive(i)} className={i===active?'is-active':''} key={s.title}><span>0{i+1}</span><i/></button>)}</div>
        </div>
      </div>
    </div>
    <div className="hero-ticker-v7" aria-hidden="true"><div><span>WEB DEVELOPMENT</span><b>✦</b><span>BUSINESS SYSTEM</span><b>✦</b><span>JAVA / SPRING</span><b>✦</b><span>REACT / VUE</span><b>✦</b><span>AUTOMATION</span><b>✦</b><span>API INTEGRATION</span><b>✦</b></div><div><span>WEB DEVELOPMENT</span><b>✦</b><span>BUSINESS SYSTEM</span><b>✦</b><span>JAVA / SPRING</span><b>✦</b><span>REACT / VUE</span><b>✦</b><span>AUTOMATION</span><b>✦</b><span>API INTEGRATION</span><b>✦</b></div></div>
  </header>
};
export default Header;
